export { View as LongHistory } from './view'
